import { Component, OnInit } from '@angular/core';
import { Project } from 'src/app/models/Project';
import { ModalController, AlertController } from '@ionic/angular';
import { ValidationService } from 'src/app/services/validation.service';
import { UnfocusElementService } from 'src/app/services/unfocus-element.service';
import { FileSizeService } from 'src/app/services/file-size.service';

@Component({
  selector: 'app-add-project-modal',
  templateUrl: './add-project-modal.page.html',
  styleUrls: ['./add-project-modal.page.scss'],
})
export class AddProjectModalPage implements OnInit {

  project: Project;
  isEditing: boolean;
  toEditor: boolean;

  constructor(
    public modalController: ModalController,
    public alertController: AlertController,
    public validationService: ValidationService,
    public unfocusService: UnfocusElementService,
    public fileSizeService: FileSizeService
  ) { }

  ngOnInit() {
    document.querySelector('#project-name-input').focus();

  }

  closeModal() {
    this.modalController.dismiss();
  }

  saveProject(event) {
    this.unfocusService.unfocus(event);
    this.project.name = this.validationService.removeHtmlTags(this.project.name);
    if (!this.validationService.isEmptyOrNull(this.project.name)) {
      this.modalController.dismiss(this.project);
    } else {
      this.alertForProjectName();
    }
  }

  async alertForProjectName() {
    const alert = await this.alertController.create({
      header: 'Project Name Required',
      buttons: [{
        text: 'Ok',
      }
      ]
    });
    await alert.present();
  }

  getProjectSize(projectSize){
    return this.fileSizeService.getProjectSizeWithMetric(projectSize);
  }

}
